<div (click)="clicked($event)" class="image-cont">
  <div *ngIf="hasNoImage" class="no-image-banner">
    <div class="banner-icon">
      <i class="fa fa-info-circle" aria-hidden="true"></i>
    </div>
    <div class="banner-content">
      <div class="banner-title">No image uploaded</div>
      <div class="banner-message">Click here to upload an image using the new CMS</div>
    </div>
  </div>
  <img #image src="{{ imageUrl }}" alt="No image to show" [ngStyle]="{ display: !this.resourceId || this.loading ? 'none' : 'initial' }" />
  <div class="loading-cont" *ngIf="loading"><div class="loading-spinner"></div></div>
</div>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/core/image-view/image-view.component.html